module.exports = __webpack_public_path__ + "static/media/pdf.0c7d4360.svg";